import { de } from 'date-fns/locale';
import type { Locale } from 'date-fns';

/**
 * date-fns-Locale passend zur Oberflächensprache.
 * Deutsch ist statisch (kein Await); alles andere wird nachgeladen.
 *
 * Verwendung:  format(date, 'PPP', { locale: dfLocale() })
 */
const loaders: Record<string, () => Promise<{ default: Locale }>> = {
  en: () => import('date-fns/locale/en-GB'),
  tr: () => import('date-fns/locale/tr'),
  fr: () => import('date-fns/locale/fr'),
  es: () => import('date-fns/locale/es'),
  it: () => import('date-fns/locale/it'),
  nl: () => import('date-fns/locale/nl'),
  pl: () => import('date-fns/locale/pl'),
  pt: () => import('date-fns/locale/pt'),
};

let active: Locale = de;

export const dfLocale = (): Locale => active;

export async function loadDateFnsLocale(code: string): Promise<void> {
  if (code === 'de') {
    active = de;
    return;
  }
  try {
    const mod = await loaders[code]?.();
    active = mod?.default ?? de;
  } catch {
    active = de;
  }
}
